import { compile } from "path-to-regexp";
import { makeBackendGetCallWithJsonResponse } from "../../store/utils/fetch";
import { PRODUCTS_BY_RELEASE_PUBLIC_ROUTE } from "../../store/utils/routes";
import { promiseEngineEarsHandler } from "../helpers";
import { ProductResponse } from "./productsAPI";

export const fetchProductsByReleaseIdPublic = async (releaseId: number) => {
  const route = compile(PRODUCTS_BY_RELEASE_PUBLIC_ROUTE)({
    release_id: releaseId,
  });
  return await makeBackendGetCallWithJsonResponse<ProductResponse[]>(
    route,
    "",
  ).then(promiseEngineEarsHandler);
};
